import { render, staticRenderFns } from "./SetAppAuth.vue?vue&type=template&id=b6368b8a&"
import script from "./SetAppAuth.vue?vue&type=script&lang=js&"
export * from "./SetAppAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports